export default __webpack_public_path__ + "img/dirNQYVO.b5f1753e.svg";